import React from 'react';
import {
  Button,
  Heading,
  Square,
  Stack,
  SvgX,
} from '@grubhubprod/gh-cookbook-react';
import { Modal } from 'src/components/Modal/Modal';

interface GroupManagementModalProps {
  isVisible: boolean;
  onClose: () => void;
  title: string;
}

export const GroupManagementModal: React.FC<GroupManagementModalProps> = ({
  isVisible,
  onClose,
  children,
  title,
}) => {
  if (!isVisible) {
    return null;
  }

  return (
    <Modal size="sm">
      <Stack y="x-sm">
        <Square as="header" dimension="2" width="100%">
          <Button
            variant="tertiary"
            type="button"
            className="closeModalButton"
            onClick={onClose}
          >
            <SvgX aria-label="close" size="24px" />
          </Button>
          <Square inset="md">
            <Heading variant="h1">{title}</Heading>
          </Square>
        </Square>
      </Stack>
      {children}
    </Modal>
  );
};
